export function getValueFromPath<DataType>(data: DataType, path: string): any {
    const pathItems = path.split('/').slice(1);
    return pathItems.reduce((acc, current) => {
        return acc[current];
    }, data);
}
